// from general.js
/* global userObj */
// from JSP?
/* global eligibleToBeCopied teacherId */


$(document).ready(function () {
    // eslint-disable-next-line no-undef
    const userType = readCookie('userType');
    const isLoggedInTeacher = userType === 'teacher';
    // eslint-disable-next-line no-undef
    const showCopyCartButton = isLoggedInTeacher && eligibleToBeCopied;
    const showCostContextMessage = !isLoggedInTeacher;
    const showDonationWrapper = !isLoggedInTeacher;

    let toggleFlag = true;
    const newWindowWidth = $(window).width();
    const ccContainer = $('.cartcopy-container');
    const ccSVG = $('.cartcopy-container svg');
    const donationWrapper = $('.donation-wrapper');

    function hideCartCopyButton() {
        $(ccContainer).css('display', 'none');
        $('.materials-wrapper .materials-table').css('box-shadow', 'none');
    }

    function checkCartCopy() {
        if (!showCostContextMessage) {
            $('.cost-context').css('opacity', '0');
        }
        if (!showDonationWrapper) {
            $(donationWrapper).css('display', 'none');
        }

        if (!showCopyCartButton) {
            hideCartCopyButton();
        }

        if (userObj.userId === teacherId) {
            hideCartCopyButton();
        }

        if (eligibleToBeCopied === true && isLoggedInTeacher === true) {
            $(donationWrapper).css('display', 'none');
            checkIfMobile();
        } else {
            $(donationWrapper).css('display', 'block');
        }

        $(ccSVG).click(function () {
            toggleFlag = false;
            $(ccContainer).removeClass('floatPosition');
            $(this).css('display', 'none');
            $(donationWrapper).css('display', 'block');
        });

        function checkIfMobile() {
            if (newWindowWidth < 736) {
                $(ccContainer).prependTo('.expand-mobile-materials').addClass('for-mobile floatPosition');
                $(ccSVG).css('display', 'block');

                $(ccSVG).click(function () {
                    toggleFlag = false;

                    $(ccContainer).removeClass('floatPosition');
                    $(this).css('display', 'none');
                    $(donationWrapper).css('display', 'block');
                });

                if (userObj.userId === teacherId) {
                    $('.mobile-donation-box').css({
                        position: 'relative',
                        'margin-top': '1rem',
                        'backdrop-filter': 'none',
                        'box-shadow': 'none',
                        'border-bottom': '1px solid rgba(65,65,66, .2)',
                    });
                }

                $(window).scroll(function () {
                    const scroll = $(window).scrollTop();
                    $(donationWrapper).css('display', 'none');

                    if (toggleFlag === true && scroll <= 2930 && userObj.userId != teacherId) {
                        $(ccContainer).addClass('floatPosition');
                        $(ccSVG).css('display', 'block');
                        $(donationWrapper).css('display', 'none');
                    } else if (toggleFlag === true && scroll >= 2930 && userObj.userId != teacherId) {
                        $(ccContainer).removeClass('floatPosition');
                        $(ccSVG).css('display', 'none');
                        $(donationWrapper).css('display', 'block');
                    } else {
                        $(ccContainer).removeClass('floatPosition');
                        $(ccSVG).css('display', 'none');
                        $(donationWrapper).css('display', 'block');
                    }

                    $(ccSVG).click(function () {
                        toggleFlag = false;
                        if (toggleFlag === false && scroll <= 2930) {
                            $(ccContainer).removeClass('floatPosition');
                            $(this).css('display', 'none');
                            $(donationWrapper).css('display', 'block');
                        }
                    });
                });

                $('.campaign-expiration-wrapper').css({ position: 'absolute', left: '-11%', 'margin-top': '-1%' });
            } else {
                $(ccContainer).addClass('floatPosition');
                $(ccSVG).click(function () {
                    toggleFlag = false;

                    $(ccContainer).removeClass('floatPosition');
                    $(this).css('display', 'none');
                });

                $(window).scroll(function () {
                    const scroll = $(window).scrollTop();

                    if (toggleFlag === true && scroll <= 800) {
                        $(ccContainer).addClass('floatPosition');
                        $(ccSVG).css('display', 'block');
                    } else if (toggleFlag === true && scroll >= 801) {
                        $(ccContainer).removeClass('floatPosition');
                        $(ccSVG).css('display', 'none');
                    }

                    $(ccSVG).click(function () {
                        toggleFlag = false;
                        if (toggleFlag === false && scroll <= 800) {
                            $(ccContainer).removeClass('floatPosition');
                            $(this).css('display', 'none');
                        }
                    });
                });
            }
        }
    }

    // re-enabling CC for 09/07
    checkCartCopy();
});
